import { c as _c } from "react/compiler-runtime";
import { NavAccount } from '../../molecules/nav-account/nav-account.tsx';
import { NavBag } from '../../molecules/nav-bag/nav-bag.tsx';
import { NavSearch } from '../../molecules/nav-search/nav-search.tsx';
type SharedProps = {
  showSearch?: boolean;
  showShoppingBag?: boolean;
  showLogin?: boolean;
  urlLogin?: string;
  urlAccountHome?: string;
  userMenu?: React.ReactNode;
};
type HeaderDesktopActionsProps = SharedProps & {
  accountTriggerRef?: React.RefObject<HTMLButtonElement | null>;
  onAccountClose?: () => void;
};
type HeaderMobileActionsProps = SharedProps & {
  onAccountOpen?: () => void;
};
const SearchAndBag: React.FC<Pick<SharedProps, 'showSearch' | 'showShoppingBag'>> = t0 => {
  const $ = _c(7);
  const {
    showSearch,
    showShoppingBag
  } = t0;
  let t1;
  if ($[0] !== showSearch) {
    t1 = showSearch && <NavSearch />;
    $[0] = showSearch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== showShoppingBag) {
    t2 = showShoppingBag && <NavBag />;
    $[2] = showShoppingBag;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const HeaderDesktopActions: React.FC<HeaderDesktopActionsProps> = t0 => {
  const $ = _c(13);
  const {
    showSearch,
    showShoppingBag,
    showLogin,
    urlLogin,
    urlAccountHome,
    userMenu,
    accountTriggerRef,
    onAccountClose
  } = t0;
  let t1;
  if ($[0] !== showSearch || $[1] !== showShoppingBag) {
    t1 = <div className="flex gap-snug-md md:gap-snug-xl"><SearchAndBag showSearch={showSearch} showShoppingBag={showShoppingBag} /></div>;
    $[0] = showSearch;
    $[1] = showShoppingBag;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== accountTriggerRef || $[4] !== onAccountClose || $[5] !== showLogin || $[6] !== urlAccountHome || $[7] !== urlLogin || $[8] !== userMenu) {
    t2 = showLogin && <NavAccount urlLogin={urlLogin} urlAccountHome={urlAccountHome} userMenu={userMenu} triggerRef={accountTriggerRef} onClose={onAccountClose} />;
    $[3] = accountTriggerRef;
    $[4] = onAccountClose;
    $[5] = showLogin;
    $[6] = urlAccountHome;
    $[7] = urlLogin;
    $[8] = userMenu;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export const HeaderMobileActions: React.FC<HeaderMobileActionsProps> = t0 => {
  const $ = _c(12);
  const {
    showSearch,
    showShoppingBag,
    showLogin,
    urlLogin,
    urlAccountHome,
    userMenu,
    onAccountOpen
  } = t0;
  let t1;
  if ($[0] !== showSearch || $[1] !== showShoppingBag) {
    t1 = <SearchAndBag showSearch={showSearch} showShoppingBag={showShoppingBag} />;
    $[0] = showSearch;
    $[1] = showShoppingBag;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onAccountOpen || $[4] !== showLogin || $[5] !== urlAccountHome || $[6] !== urlLogin || $[7] !== userMenu) {
    t2 = showLogin && <NavAccount urlLogin={urlLogin} urlAccountHome={urlAccountHome} userMenu={userMenu} asTriggerOnly={true} onOpen={onAccountOpen} />;
    $[3] = onAccountOpen;
    $[4] = showLogin;
    $[5] = urlAccountHome;
    $[6] = urlLogin;
    $[7] = userMenu;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};